import React, { useEffect, useState, useRef } from 'react';
import services from '../../services';
import { toast } from 'react-toastify';
import Loading from '../../utils/Loading';
import Select from 'react-dropdown-select';
import { Tooltip } from 'react-tooltip';
import EditorComponent from '../Template/Editor';

const ComposeEmail = ({
    currentTaskId,
    replyDropdown,
    subject,
    selectedMail,
    setComposeStatus,
    setLoading,
    attachmentPaths,
    boardId,
    getTaskById,
    childTaskData,
    taskID,
    originalEmail,
    boardListId,
    setLabelAnchorEl,
    setIsSend,
    labelname,
    setLabelname

}) => {
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [compose, setCompose] = useState({
        sentTo: '',
        subject: '',
        body: '',
        parentTaskID: '',
        parentTaskStatus: '',
        sentBy: '',
        boardId: '',
    });

    const [gmailUsers, setGmailUsers] = useState([]);
    const [templateselect, setTemplateselect] = useState([]);
    const [template, setTemplate] = useState({
        templateData: '',
    });
    const [allTemp, setAllTemp] = useState([]);

    const [bodyManuallyEdited, setBodyManuallyEdited] = useState(false);
    const [editorKey, setEditorKey] = useState('compose-editor');
    const prevReplyDropdown = useRef(replyDropdown);
    const prevAllTempLength = useRef(allTemp?.length);
    const [showCc, setShowCc] = useState(false);
    const [showBcc, setShowBcc] = useState(false);
    const [draftStatus, setDraftStatus] = useState("");
    const [draftId, setDraftId] = useState(null);

    const handleDelete = () => {
        setComposeStatus(false);
        setLabelname([]);
    }

    useEffect(() => {
        let shouldRemount = false;
        if (!prevReplyDropdown.current && replyDropdown) {
            shouldRemount = true;
        }
        if (prevAllTempLength.current === 0 && allTemp?.length > 0) {
            shouldRemount = true;
        }
        if (shouldRemount) {
            setEditorKey('compose-editor-' + Date.now());
        }
        prevReplyDropdown.current = replyDropdown;
        prevAllTempLength.current = allTemp?.length;
    }, [replyDropdown, allTemp]);

    useEffect(() => {
        if (!selectedMail) return;
        const rawSentBy = selectedMail?.Email?.sentBy;
        const rawSentTo = selectedMail?.Email?.sentTo;
        const sentByEmail = rawSentBy?.match(/<([^>]+)>/)?.[1] || rawSentBy;
        const sentToEmail = rawSentTo?.match(/<([^>]+)>/)?.[1] || rawSentTo;

        setCompose((prev) => ({
            ...prev,
            parentTaskID: currentTaskId || selectedMail.id,
            parentTaskStatus: true,
            sentBy: '',
            boardListId: boardListId || selectedMail.boardListId,
            sentTo: '',
            attachmentPaths: [],
            body: '',
            subject: '',
            boardId: boardId,
        }));
    }, [selectedMail]);

    const getAllLinkedEmail = async () => {
        try {
            const isMailSend = true;
            const urlParams = new URLSearchParams();
            urlParams.append('isMailSend', isMailSend);
            const response = await services.email.Get_The_Linked_Email(urlParams);
            if (response) {
                const options = response?.data?.map((email) => ({
                    label: email.email,
                    value: email.id,
                    color: email.colour,
                }));
                setGmailUsers(options);
                setCompose((prev) => {
                    const sentByEmail = selectedMail?.Email?.sentBy?.match(/<([^>]+)>/)?.[1];
                    const sentToEmail = selectedMail?.Email?.sentTo?.match(/<([^>]+)>/)?.[1];
                    const matchedSendTo = options.find((e) => e.label === sentByEmail);
                    const matchedSendBy = options.find((e) => e.label === sentToEmail);

                    let finalEmail = '';
                    let finalSource = '';
                    if (matchedSendTo && matchedSendBy) {
                        finalEmail = matchedSendTo.label;
                        finalSource = 'sendTo';
                    } else if (matchedSendTo) {
                        finalEmail = matchedSendTo.label;
                        finalSource = 'sendTo';
                    } else if (matchedSendBy) {
                        finalEmail = matchedSendBy.label;
                        finalSource = 'sendBy';
                    } else if (options.length > 0) {
                        finalEmail = options[0].label;
                        finalSource = 'default';
                    }
                    return {
                        ...prev,
                        sentBy: prev.sentBy || finalEmail,
                    };
                });
            }
        } catch (error) {
            console.error('error', error);
        }
    };
    const updateDraft = async () => {
        try {
            const formData = new FormData();
            formData.append("draftId", draftId);
            formData.append("sentTo", compose.sentTo);
            formData.append("body", compose.body);
            formData.append("subject", compose.subject);
            formData.append("bcc", compose.bcc || "");
            formData.append("cc", compose.cc || "");

            uploadedFiles.forEach((file) => {
                formData.append("attachments", file);
            });

            // await services.draft.UPDATE_DRAFT(draftId, formData);
            setDraftStatus("Draft Saved");
            setTimeout(() => setDraftStatus(""), 3000);
        } catch (e) {
            console.error("Draft update failed", e);
            setDraftStatus("Failed to update draft");
        }
    };
    const saveDraft = async () => {
        try {
            const formData = new FormData();
            formData.append('parentTaskID', compose.parentTaskID);

            formData.append("sentBy", compose.sentBy);
            formData.append("boardListId", compose.boardListId);
            formData.append("sentTo", compose.sentTo);
            formData.append("body", compose.body);
            formData.append("subject", compose.subject);
            formData.append("boardId", compose.boardId);
            formData.append("bcc", compose.bcc || "");
            formData.append("cc", compose.cc || "");

            uploadedFiles.forEach((file) => {
                formData.append("attachments", file);
            });
            // const res = await services.draft.CREATE_DRAFT(formData);
            setDraftId(res?.data?.data?.id);
            setDraftStatus("Draft saved");
            setTimeout(() => setDraftStatus(""), 3000);
        } catch (e) {
            console.error("Draft create failed", e);
            setDraftStatus("Failed to save draft");
        }
    };

    // useEffect(() => {
    //     if (!compose.sentTo) return;
    //     const delay = setTimeout(() => {
    //         if (draftId) {
    //             updateDraft();
    //         } else {
    //             saveDraft();
    //         }
    //     }, 2000);

    //     return () => clearTimeout(delay);
    // }, [compose]);


    useEffect(() => {
        getAllLinkedEmail();
    }, []);

    const handleSubmit = async () => {
        const formData = new FormData();
        formData.append('parentTaskID', compose.parentTaskID);
        formData.append('parentTaskStatus', compose.parentTaskStatus);
        formData.append('sentBy', compose.sentBy);
        formData.append('boardListId', compose.boardListId);
        formData.append('sentTo', compose.sentTo);
        formData.append('body', compose.body);
        formData.append('subject', compose.subject);
        formData.append('boardId', compose.boardId);
        formData.append('bcc', compose.bcc || '');
        formData.append('cc', compose.cc || '');

        uploadedFiles.forEach((file) => {
            formData.append('attachments', file);
        });

        try {
            setIsUploading(true);
            await services.compose.SEND_COMPOSE(formData);
            // await services.draft.DELETE_BY_ID_DRAFT(draftId)
            setComposeStatus(false);
            setLabelname([]);
            toast.success('Compose Email Sent Successfully...');

            getTaskById(taskID);
            setIsSend(true)

        } catch (e) {
            console.error(e);
            toast.error('Failed to send email');
        } finally {
            setIsUploading(false);
        }
    };

    const handleRemoveFile = (index) => {
        setCompose((prev) => ({
            ...prev,
            attachmentPaths: [],
        }));
        setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const MAX_IMAGES = 10;

    const handleFileChange = (e) => {
        if (e.target.files) {
            const newFiles = Array.from(e.target.files);
            if (uploadedFiles.length + newFiles.length > MAX_IMAGES) {
                toast.error(`You can only select up to ${MAX_IMAGES} images.`);
                return;
            }
            setUploadedFiles((prev) => [...prev, ...newFiles]);
        }
    };

    const getTemplate = async () => {
        try {
            const response = await services.template.GET_ALL_TEMPLATE();
            if (response && Array.isArray(response.templates) && response.templates.length > 0) {
                const filteredTemplates = response.templates.filter(item => item.status === true);
                const mappedTemplates = filteredTemplates.map(item => ({
                    label: item.name || '',
                    value: item.body || '',
                    subject: item.subject || "",
                    displayValue: (item.body || '').replace(/\n/g, ' ')
                }));
                setAllTemp(mappedTemplates);
            } else {
                setAllTemp([]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getTemplate();
    }, [selectedMail]);

    useEffect(() => {
        if (!templateselect) {
            setCompose(prev => ({ ...prev, body: "" }));
            setBodyManuallyEdited(false);
            return;
        }

        const selected = allTemp?.length > 0 && allTemp?.find(option => option.value === templateselect);
        if (selected && !bodyManuallyEdited) {
            let templateBody = selected.value || '';
            setCompose(prev => ({
                ...prev,
                body: templateBody,
            }));
        }
    }, [templateselect, allTemp, bodyManuallyEdited]);
    const isValidEmail = (email) => {
        if (!email) return true;
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };


    return (
        <div
            className={`replydropdown p-2 mailreply-dropbox ${replyDropdown ? 'open' : ''
                }  kanban-dropDown  text-black shadow-md`}
            style={{ width: '100%' }}
        >
            <div className="">
                {isUploading ? <Loading /> : <>
                    <h2 className="text-lg font-semibold text-gray-800 flex justify-between items-center">
                        New Message
                        {draftStatus && (
                            <span className="text-sm text-gray-500">{draftStatus}</span>
                        )}
                    </h2>
                    <span onClick={(e) => {
                        e.stopPropagation();
                        setLabelAnchorEl(e.currentTarget);
                    }} className='p-1 px-2 rounded-5 mb-5' style={{ fontSize: '10px', backgroundColor: '#E0E0E0' }}>{labelname.length > 0 ? labelname.join(', ') : 'Add a label'}</span>
                    <div className="mb-4 mt-3">
                        <label className="block text-sm font-medium text-gray-700 mb-1">From</label>

                        {/* <input
                            type="text"
                            className="block w-full px-3 py-2 rounded-md border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 text-sm"
                            value={compose.sentBy || ''}
                            onChange={(e) =>
                                setCompose((prev) => ({
                                    ...prev,
                                    sentBy: e.target.value,
                                }))
                            }
                        /> */}
                        <Select
                            className="block w-full px-3 py-2 rounded-md border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 text-sm"
                            options={gmailUsers}
                            value={compose.sentBy}
                            onChange={(e) =>
                                setCompose((prev) => ({
                                    ...prev,
                                    sentBy: e.value,
                                }))
                            }
                        />

                    </div>
                    <div className="mb-4">
                        <div className="flex items-center justify-between">
                            <label className="text-sm font-medium text-gray-700">To</label>
                            <div className="flex gap-4 text-sm text-black-600 cursor-pointer">
                                {!showCc && (
                                    <span onClick={() => setShowCc(true)} className="hover:underline">
                                        Cc
                                    </span>
                                )}
                                {!showBcc && (
                                    <span onClick={() => setShowBcc(true)} className="hover:underline">
                                        Bcc
                                    </span>
                                )}
                            </div>
                        </div>

                        <input
                            id="recipients"
                            placeholder="To"
                            type="email"
                            className={`block w-full px-3 py-2 rounded-md border ${compose?.sentTo
                                ? "border-red-500"
                                : "border-gray-300"
                                } shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 text-sm`}
                            value={compose?.sentTo}
                            onChange={(e) => {
                                const value = e.target.value;
                                setCompose((prev) => ({ ...prev, sentTo: value }));
                            }}
                        />

                        {showCc && (
                            <div className="mb-2">
                                <label className="text-sm font-medium text-gray-700">Cc</label>
                                <input
                                    type="email"
                                    placeholder="Cc"
                                    className={`block w-full px-3 py-2 mt-1 rounded-md border ${compose?.cc
                                        ? "border-red-500"
                                        : "border-gray-300"
                                        } shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm`}
                                    value={compose?.cc || ""}
                                    onChange={(e) => setCompose((prev) => ({ ...prev, cc: e.target.value }))}
                                />

                            </div>
                        )}
                        {showBcc && (
                            <div className="mb-2">
                                <label className="text-sm font-medium text-gray-700">Bcc</label>
                                <input
                                    type="email"
                                    placeholder="Bcc"
                                    className={`block w-full px-3 py-2 mt-1 rounded-md border ${compose?.bcc
                                        ? "border-red-500"
                                        : "border-gray-300"
                                        } shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm`}
                                    value={compose?.bcc || ""}
                                    onChange={(e) => setCompose((prev) => ({ ...prev, bcc: e.target.value }))}
                                />

                            </div>
                        )}

                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Template</label>
                        <select
                            className="block w-full px-3 py-2 rounded-md border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 text-sm"
                            value={templateselect || ''}
                            onChange={(e) => {

                                const value = e.target.value;
                                const selectedTemplate = allTemp?.find(
                                    (template) => template.value === value
                                );
                                setTemplateselect(value);
                                setTemplate((prev) => ({
                                    ...prev,
                                    templateData: value,
                                }));
                                setCompose((prev) => ({
                                    ...prev,
                                    subject: selectedTemplate?.subject || '',
                                }));

                                if (!value) {
                                    setCompose((prev) => ({
                                        ...prev,
                                        body: '',
                                    }));
                                    setBodyManuallyEdited(false);
                                }
                            }}
                        >
                            <option value="">Select Template</option>
                            {allTemp?.length > 0 && allTemp?.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                        <input
                            id="subject"
                            placeholder="Subject"
                            type="text"
                            className="block w-full px-3 py-2 rounded-md border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 text-sm"
                            value={compose?.subject}
                            onChange={(e) => setCompose((prev) => ({ ...prev, subject: e.target.value }))}
                        />
                    </div>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                        <EditorComponent
                            key={editorKey}
                            selectedPrevData={{ templateData: compose.body }}
                            handleEditorChange={(data) => setCompose((prev) => ({ ...prev, body: data }))}
                            allTemp={allTemp}

                        />
                    </div>
                    {uploadedFiles.length > 0 && (
                        <div className="bg-[#FAFAFA] border border-[#EAEAEA] rounded-md p-3 mb-4">
                            <div className="flex flex-wrap gap-4">
                                {uploadedFiles.map((file, idx) =>
                                    file.type.startsWith('image/') ? (
                                        <div className="email-file-preview" key={idx}>
                                            <img
                                                src={URL.createObjectURL(file)}
                                                alt={`Preview ${idx}`}
                                                className="rounded-md w-24 h-24 object-cover shadow"
                                            />
                                            <button
                                                onClick={() => handleRemoveFile(idx)}
                                                className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                                title="Remove"
                                            >
                                                &times;
                                            </button>
                                        </div>
                                    ) : (
                                        <div key={idx} className="email-file-preview flex items-center gap-2 bg-white rounded px-2 py-1 shadow">
                                            <span>{file.name}</span>
                                            {file.type === 'application/pdf' && <span className="text-xs text-gray-500">(PDF)</span>}
                                            <button
                                                onClick={() => handleRemoveFile(idx)}
                                                className="bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                                title="Remove"
                                            >
                                                &times;
                                            </button>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    )}


                    <div className="flex items-center justify-between w-full mt-4">
                        <div className="flex items-center gap-4">
                            <button
                                onClick={handleSubmit}
                                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-full px-8 py-2 shadow-sm flex items-center gap-2 text-[15px] transition"
                            >
                                {isUploading ? 'Sending...' : 'Send'}
                            </button>

                            <label
                                data-tooltip-id="upload-tooltip"
                                data-tooltip-content="Attach files"
                                className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 cursor-pointer"
                            >
                                <input
                                    type="file"
                                    accept="image/*,application/pdf"
                                    multiple
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                />
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    className="bi bi-paperclip"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
                                </svg>
                            </label>

                            <Tooltip id="upload-tooltip" place="top" style={{ fontSize: '12px', marginBottom: '5px' }} />
                        </div>

                        <button onClick={handleDelete}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                className="text-gray-500"
                                viewBox="0 0 16 16"
                            >
                                <path d="M5.5 5.5A.5.5 0 0 1 6 5h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7H6v7a.5.5 0 0 1-1 0v-7z" />
                                <path
                                    fillRule="evenodd"
                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1 0-2H5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1h2.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3a.5.5 0 0 0-.5.5V4h12v-.5a.5.5 0 0 0-.5-.5h-11z"
                                />
                            </svg>
                        </button>
                    </div>

                </>}
            </div>
        </div>
    );
};

export default ComposeEmail;
